import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@/contexts/ThemeContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Menu from "@/pages/Menu";
import Gallery from "@/pages/Gallery";
import Reservation from "@/pages/Reservation";
import Contact from "@/pages/Contact";

export default function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/"            element={<Home />} />
            <Route path="/menu"        element={<Menu />} />
            <Route path="/galerie"     element={<Gallery />} />
            <Route path="/reservation" element={<Reservation />} />
            <Route path="/contact"     element={<Contact />} />
            <Route path="*"            element={<Home />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}
